namespace TabAurous.ECommerce {
    export interface ShippingRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        POSCustomerId?: number;
        FirstName?: string;
        LastName?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        PanNumber?: string;
        Address?: string;
        CountryId?: number;
        StateId?: number;
        CityId?: number;
        TermsId?: number;
        BaseItemTypeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        ReceiptAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: ShippingItemsRow[];
        ECommOrderId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        OrderStatusId?: number;
        OrderStatusName?: string;
        PickupDate?: string;
        PickupTime?: string;
        LabelId?: string;
        AWBNumber?: string;
        FreightId?: number;
    }

    export namespace ShippingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.Shipping';
        export const lookupKey = 'ECommerce.Shipping';

        export function getLookup(): Q.Lookup<ShippingRow> {
            return Q.getLookup<ShippingRow>('ECommerce.Shipping');
        }
        export const deletePermission = 'Retail:Shipping:Delete';
        export const insertPermission = 'Retail:Shipping:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:Shipping:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            FirstName = "FirstName",
            LastName = "LastName",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            PanNumber = "PanNumber",
            Address = "Address",
            CountryId = "CountryId",
            StateId = "StateId",
            CityId = "CityId",
            TermsId = "TermsId",
            BaseItemTypeId = "BaseItemTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            ReceiptAmount = "ReceiptAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            ECommOrderId = "ECommOrderId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            OrderStatusId = "OrderStatusId",
            OrderStatusName = "OrderStatusName",
            PickupDate = "PickupDate",
            PickupTime = "PickupTime",
            LabelId = "LabelId",
            AWBNumber = "AWBNumber",
            FreightId = "FreightId"
        }
    }
}
